<template>
  <v-btn v-if="showButton" small color="secondary" class="back-to-top-button" rounded fixed bottom @click="scrollToTop">
    Back to Top
    <v-icon>expand_less</v-icon>
  </v-btn>
</template>
<script>
export default {
  data() {
    return {
      showButton: false
    }
  },
  beforeMount() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll(event) {
      this.showButton = window.scrollY > 500
    },
    scrollToTop() {
      this.$vuetify.goTo(0)
    }
  }
}
</script>
<style scoped>
  .back-to-top-button {
    width: 137px;
    z-index: 100;
    left: calc(50% - 68.5px);
  }
</style>